module.exports = __webpack_public_path__ + "0370d8c00a75281a0924df14c1c8c505.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/error.svg
// module id = 1206
// module chunks = 0